import React from 'react';
import { Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from './styles/theme';
import { SectionTitle, MetricCard, ChartContainer } from './components';
import icoUser from '../../img/ico_User.png';
import icoUsers from '../../img/ico_Users.png';

const styles = StyleSheet.create({
  container: {
    paddingBottom: spacing.lg,
  },
  metricsRow: {
    flexDirection: 'row',
    marginBottom: spacing.lg,
  },
  metricColumn: {
    flex: 1,
    paddingRight: spacing.md,
  },
  metricColumnLast: {
    flex: 1,
    paddingLeft: spacing.md,
  },
  summaryText: {
    ...typography.body,
    marginBottom: spacing.xl,
    paddingHorizontal: spacing.sm,
  },
  chartSection: {
    marginTop: spacing.md,
  },
});

const Page2 = ({
  totalUsers = 0,
  totalConcurrences = 0,
  c1 = null,
}) => {
  const viewerText = totalUsers === 1 ? 'espectador' : 'espectadores';
  const concurrentText = totalConcurrences === 1 ? 'espectador' : 'espectadores';
  const simultaneousText = totalConcurrences === 1 ? 'simultáneo' : 'simultáneos';

  return (
    <View style={styles.container}>
      <SectionTitle title="Reporte de Audiencia" />

      {/* KPI Metrics */}
      <View style={styles.metricsRow}>
        <View style={styles.metricColumn}>
          <MetricCard
            value={totalUsers.toLocaleString()}
            label="Total de Personas"
            description="Espectadores únicos que accedieron a la transmisión"
            icon={icoUser}
          />
        </View>
        <View style={styles.metricColumnLast}>
          <MetricCard
            value={totalConcurrences.toLocaleString()}
            label="Pico de Concurrencia"
            description="Máximo de conexiones simultáneas registradas"
            icon={icoUsers}
            accentColor={colors.accent}
          />
        </View>
      </View>

      {/* Summary Text */}
      <Text style={styles.summaryText}>
        Tu transmisión tuvo {totalUsers.toLocaleString()} {viewerText}, alcanzando
        un máximo de {totalConcurrences.toLocaleString()} {concurrentText}{' '}
        {simultaneousText} durante la emisión del evento.
      </Text>

      {/* Cities Chart */}
      <View style={styles.chartSection}>
        <ChartContainer
          title="Espectadores Conectados por Ciudad"
          chartImage={c1}
          chartHeight={200}
          description="Esta gráfica representa la cantidad de espectadores únicos que ingresaron a tu transmisión, agrupados por ciudad de origen."
        />
      </View>
    </View>
  );
};

export default Page2;
